export const SUPPORTED_LOCALES = ["en", "pl"] as const;
export const DEFAULT_LOCALE = "pl";
